module.exports = __webpack_public_path__ + "static/media/pdf.2bdd26a8.png";